import type { Language } from "./types";
import type { PdfTemplateLabels } from "./pdfReportLabels";

export type TextSchema = {
  productName: string;
  navHome: string;
  navBilling: string;
  navDashboard: string;
  navWorkspace: string;
  navStudio: string;
  /** 个人信息侧栏：进入 Studio（流光按钮） */
  navEnterStudio: string;
  studioBackToWorkspace: string;
  studioBackToChat: string;
  studioNavNewScan: string;
  studioNavRecords: string;
  studioBrandSub: string;
  /** 顶栏剩余扫描次数，{n} 为数字 */
  studioTopbarScansRemainingTpl: string;
  studioTopbarScansUnlimited: string;
  studioCrumbScan: string;
  studioCrumbRecords: string;
  studioCrumbDetail: string;
  studioCrumbMonitoring: string;
  studioCrumbCompare: string;
  studioNavMonitoring: string;
  studioNavCompare: string;
  studioCompareTitle: string;
  studioCompareSubtitleNone: string;
  studioCompareSubtitleSeriesTpl: string;
  studioCompareDateFrom: string;
  studioCompareDateTo: string;
  studioCompareRisk: string;
  studioCompareRiskAll: string;
  studioCompareRiskHigh: string;
  studioCompareRiskMed: string;
  studioCompareRiskLow: string;
  studioCompareSeries: string;
  studioCompareSeriesPh: string;
  studioCompareApply: string;
  studioComparePickSeries: string;
  studioCompareNoRows: string;
  studioCompareVersionA: string;
  studioCompareVersionB: string;
  studioComparePickOlder: string;
  studioComparePickNewer: string;
  studioCompareRiskScore: string;
  studioCompareFlaggedCountTpl: string;
  studioCompareNoFindings: string;
  studioCompareSelectTwo: string;
  studioCompareResolvedNTpl: string;
  studioCompareNewNTpl: string;
  studioCompareCurrentScore: string;
  studioCompareFlaggedCountBTpl: string;
  studioCompareFixedPrefix: string;
  studioCompareNoDelta: string;
  studioCompareScoreProgress: string;
  studioCompareGrowth: string;
  studioCompareInsight: string;
  studioCompareInsightBodyTpl: string;
  studioCompareInsightEmpty: string;
  studioCompareExportDelta: string;
  studioCompareTimeline: string;
  studioComparePlanned: string;
  studioComparePlannedHint: string;
  studioCompareLogs: string;
  studioCompareLogsLead: string;
  studioCompareColVersion: string;
  studioCompareColCompare: string;
  studioCompareBadgeNew: string;
  studioCompareExportJsonOk: string;
  studioCompareExportLogsOk: string;
  studioMonGenReport: string;
  studioMonPrefsTitle: string;
  studioMonPrefsLead: string;
  studioMonMasterLabel: string;
  studioMonMasterHint: string;
  studioMonEmailLabel: string;
  studioMonFreqLabel: string;
  studioMonFreqRealtime: string;
  studioMonFreqDigest: string;
  studioMonTopicsLabel: string;
  studioMonTopicsMax: string;
  studioMonTopicsHint: string;
  studioMonAddTopic: string;
  studioMonAddCustomTopic: string;
  studioMonTopicsLoadFailed: string;
  studioMonPickTopicModalTitle: string;
  studioMonPickTopicEmpty: string;
  studioMonCustomTopicModalTitle: string;
  studioMonCustomLabelZh: string;
  studioMonCustomLabelEn: string;
  studioMonCustomKeywords: string;
  studioMonCustomKeywordsPh: string;
  studioMonCustomSubmit: string;
  studioMonCustomCancel: string;
  studioMonCustomCreated: string;
  studioMonUserTopicDeleted: string;
  studioMonSavePrefs: string;
  studioMonSignalsTitle: string;
  studioMonSignalsSubtitle: string;
  studioMonSignalsExplain: string;
  studioMonSourceAll: string;
  studioMonKeywordPlaceholder: string;
  studioMonApplySearch: string;
  studioMonTestNotify: string;
  studioMonAnalyzeImpact: string;
  studioMonSourceFda: string;
  studioMonSourceFtc: string;
  studioMonSourceRss: string;
  studioMonStatusHighMatch: string;
  studioMonStatusDirect: string;
  studioMonStatusInfo: string;
  studioMonSig1Time: string;
  studioMonSig1Title: string;
  studioMonSig1Desc: string;
  studioMonSig1T1: string;
  studioMonSig1T2: string;
  studioMonSig2Time: string;
  studioMonSig2Title: string;
  studioMonSig2Desc: string;
  studioMonSig2T1: string;
  studioMonSig2T2: string;
  studioMonSig3Time: string;
  studioMonSig3Title: string;
  studioMonSig3Desc: string;
  studioMonSig3T1: string;
  studioMonSig3T2: string;
  studioMonTopicSunscreen: string;
  studioMonTopicProbiotics: string;
  studioMonTopicFtcClaims: string;
  studioMonTopicOtc: string;
  studioMonSignalsEmpty: string;
  studioMonSignalsLoadFailed: string;
  studioMonSubscriptionLoadFailed: string;
  studioMonPrefsSaved: string;
  studioMonPrefsSaveFailed: string;
  studioDetailBack: string;
  studioDetailFinalizeReport: string;
  studioDetailFinalizeAgain: string;
  studioDetailFinalizeConfirmTitle: string;
  studioDetailFinalizeConfirmBody: string;
  studioDetailFinalizeOk: string;
  studioDetailFinalizeCancel: string;
  studioDetailFinalizeSuccess: string;
  studioDetailFinalizeFailed: string;
  studioDetailExportPdf: string;
  studioExportPdfTitle: string;
  studioExportPdfCoverLine1: string;
  studioExportPdfCoverLine2: string;
  studioExportPdfLogoLine1: string;
  studioExportPdfLogoLine2: string;
  studioExportPdfUploadHint: string;
  studioExportPdfDisclaimer: string;
  studioExportPdfGenerate: string;
  studioExportPdfCancel: string;
  studioExportPdfPreview: string;
  studioExportPdfZoom: string;
  studioExportPdfZoomIn: string;
  studioExportPdfZoomOut: string;
  studioExportPdfZoomReset: string;
  studioExportPdfLogoInvalidType: string;
  studioExportPdfLogoUploadOk: string;
  studioExportPdfLogoRemove: string;
  studioExportPdfGenerating: string;
  studioExportPdfDownloadOk: string;
  studioExportPdfDownloadFailed: string;
  studioPdfReportTitle: string;
  studioPdfSummaryTitle: string;
  studioPdfFindingsTitle: string;
  studioPdfRegsTitle: string;
  studioPdfAppendixTitle: string;
  studioPdfReportId: string;
  studioPdfGeneratedDate: string;
  studioPdfCategory: string;
  studioPdfSkuRef: string;
  studioPdfCompany: string;
  studioPdfSummaryAssessment: string;
  studioPdfOverallRiskPrefix: string;
  studioPdfCoverDisclaimer: string;
  studioPdfComplianceScore: string;
  studioPdfAnalysisScope: string;
  studioPdfTargetMarket: string;
  studioPdfChannel: string;
  studioPdfWordCount: string;
  studioPdfProductType: string;
  studioPdfRiskStats: string;
  studioPdfRiskHigh: string;
  studioPdfRiskMed: string;
  studioPdfRiskLow: string;
  studioPdfExecSummary: string;
  studioPdfColPhrase: string;
  studioPdfColRisk: string;
  studioPdfColReason: string;
  studioPdfColSuggest: string;
  studioPdfImpact: string;
  studioPdfDefaultMarket: string;
  studioPdfDefaultChannel: string;
  studioPdfBrandSentinel: string;
  studioPdfNoFlagged: string;
  studioPdfNoSummary: string;
  studioPdfNoClaims: string;
  studioPdfRiskCritical: string;
  studioPdfRiskWarning: string;
  studioPdfRiskObservation: string;
  studioPdfRegMatchTitle: string;
  studioPdfRegEvidenceImpact: string;
  studioPdfRegEx1Title: string;
  studioPdfRegEx1Body: string;
  studioPdfRegEx1Impact: string;
  studioPdfRegEx2Title: string;
  studioPdfRegEx2Body: string;
  studioPdfRegEx2Impact: string;
  studioPdfRegEx3Title: string;
  studioPdfRegEx3Body: string;
  studioPdfRegEx3Impact: string;
  studioRecordsTitle: string;
  studioRecordsEmpty: string;
  studioRecordsNoData: string;
  studioRecordsColWhen: string;
  studioRecordsColProduct: string;
  studioRecordsColId: string;
  studioRecordsColScore: string;
  studioRecordsColRisk: string;
  studioRecordsActionDetail: string;
  studioRecordsRiskHigh: string;
  studioRecordsRiskMed: string;
  studioRecordsRiskLow: string;
  studioRecordsHeadline: string;
  studioRecordsBcRoot: string;
  studioRecordsSyncLine: string;
  studioRecordsExportAll: string;
  studioRecordsSearchPh: string;
  studioRecordsFilters: string;
  studioRecordsRiskLevelLabel: string;
  studioRecordsPillHigh: string;
  studioRecordsPillMedium: string;
  studioRecordsPillLow: string;
  studioRecordsThTime: string;
  studioRecordsThProduct: string;
  studioRecordsThScanId: string;
  studioRecordsThCompliance: string;
  studioRecordsThRiskTag: string;
  studioRecordsThActions: string;
  studioRecordsViewDetail: string;
  studioRecordsTagCritical: string;
  studioRecordsTagHighRisk: string;
  studioRecordsTagMedium: string;
  studioRecordsTagSecure: string;
  studioRecordsBatchTitle: string;
  studioRecordsBatchDesc: string;
  studioRecordsBatchCta: string;
  studioRecordsHealthTitle: string;
  studioRecordsHealthDesc: string;
  studioComingShort: string;
  studioMonTopicsAllAdded: string;
  studioMonTestNotifySent: string;
  studioMonTestNotifyDenied: string;
  studioMonTestNotifyUnsupported: string;
  studioMonExportReportOk: string;
  studioRecordsExported: string;
  studioRecordsBatchSummaryOk: string;
  studioDetailDisclaimerCopied: string;
  studioDetailDisclaimerCopyFailed: string;
  studioDetailCompareAdded: string;
  sheCompareNeedScanFirst: string;
  sheNoScansTitle: string;
  sheNoScansLead: string;
  sheNoScansLeadSub: string;
  sheRunFirstScan: string;
  sheCompareBadge: string;
  sheCompareTitle: string;
  sheCompareDesc: string;
  sheCompareDescSub: string;
  sheSelectHistory: string;
  sheAlertsTitle: string;
  sheAlertsDesc: string;
  sheAlertsDescSub: string;
  sheConfigureAlerts: string;
  studioFormTitle: string;
  studioFormSubtitle: string;
  studioMetaTitle: string;
  studioInternalName: string;
  studioInternalNamePh: string;
  studioVerticalLabel: string;
  studioVerticalCosmetic: string;
  studioVerticalFood: string;
  studioVerticalSupplement: string;
  studioVerticalBaby: string;
  studioClaimsTitle: string;
  studioClaimsHint: string;
  studioClaimsPh: string;
  studioOptionsTitle: string;
  studioOptFda: string;
  studioOptFdaDesc: string;
  studioOptSeries: string;
  studioOptSeriesDesc: string;
  studioSeriesLabel: string;
  studioSeriesPlaceholder: string;
  studioSeriesNewBtn: string;
  studioSeriesCreateModalTitle: string;
  studioSeriesNamePh: string;
  studioSeriesCreateSuccess: string;
  studioSeriesNeedSelect: string;
  studioSeriesNameRequired: string;
  studioSeriesLoadFailed: string;
  studioSeriesSyncFailed: string;
  studioSaveDraft: string;
  studioRunScan: string;
  studioScanning: string;
  studioEstTime: string;
  studioRiskPanelTitle: string;
  studioRiskDisease: string;
  studioRiskAdditive: string;
  studioRiskIngredient: string;
  studioRiskComparative: string;
  studioRiskEco: string;
  studioAuditTitle: string;
  studioAuditBody: string;
  studioNeedHelpTitle: string;
  studioNeedHelpBody: string;
  studioDocLink: string;
  studioDetailTitle: string;
  studioContinueScan: string;
  studioNoClaims: string;
  studioScanFailed: string;
  studioFdaEvidence: string;
  navFeedback: string;
  headerBadge: string;
  loginEntry: string;
  logoutEntry: string;
  userMenuConsoleOverview: string;
  openConsole: string;
  heroTitle: string;
  slogan: string;
  subtitle: string;
  heroPrimaryAction: string;
  heroSecondaryAction: string;
  heroHighlights: string[];
  heroStatScans: string;
  heroStatAccuracy: string;
  heroStatUpdates: string;
  heroFlowTitle: string;
  heroFlows: string[];
  authorityTitle: string;
  authorityDesc: string;
  authorityItems: string[];
  ruleVersionLabel: string;
  ruleVersionValue: string;
  lastSyncLabel: string;
  sourceLabel: string;
  sourceValue: string;
  fdaStatusLabel: string;
  fdaStatusOnline: string;
  fdaStatusOffline: string;
  loginRequiredTitle: string;
  loginRequiredDesc: string;
  loginNow: string;
  sessionExpiredTitle: string;
  sessionExpiredDesc: string;
  sessionExpiredGoLogin: string;
  later: string;
  focusTitle: string;
  focusDesc: string;
  focusItems: string[];
  productFocusTitle: string;
  productFocusItems: string[];
  claimFocusTitle: string;
  claimFocusItems: string[];
  scanInputTitle: string;
  chatHistoryTitle: string;
  newChat: string;
  assistantWelcome: string;
  chatInputPlaceholder: string;
  sendMessage: string;
  executeReview: string;
  scanToolkitEntry: string;
  scanToolkitShort: string;
  scanToolkitProTag: string;
  scanToolkitLockedTitle: string;
  scanToolkitLockedBody: string;
  complianceHubTitle: string;
  complianceHubLead: string;
  complianceHubPdfTitle: string;
  complianceHubPdfDesc: string;
  complianceHubCompareTitle: string;
  complianceHubCompareDesc: string;
  complianceHubAlertsTitle: string;
  complianceHubAlertsDesc: string;
  complianceHubLockedTitle: string;
  complianceHubLockedLead: string;
  reviewCosts: string;
  chatModeHint: string;
  creditsLabel: string;
  currentPlanLabel: string;
  freeChatReply: string;
  reviewUpsell: string;
  outOfCredits: string;
  upgradePlanNow: string;
  scanningReply: string;
  scanInputPlaceholder: string;
  uploadLabel: string;
  uploadButton: string;
  scanButton: string;
  scanning: string;
  resultTitle: string;
  scoreLabel: string;
  riskLevel: string;
  phrase: string;
  reason: string;
  suggestion: string;
  emptyResult: string;
  pricingTitle: string;
  pricingFree: string;
  pricingOneTime: string;
  pricingMonth: string;
  pricingYear: string;
  targetUsersTitle: string;
  targetUsers: string[];
  fdaTitle: string;
  fdaDesc: string;
  fdaButton: string;
  fdaOk: string;
  fdaFail: string;
  pricingHeroTitle: string;
  pricingHeroDesc: string;
  pricingFeatureTitle: string;
  pricingFeatures: string[];
  priceFreeName: string;
  priceFreeValue: string;
  priceFreePoints: string[];
  priceSingleName: string;
  priceSingleValue: string;
  priceSinglePoints: string[];
  priceMonthName: string;
  priceMonthValue: string;
  priceMonthPoints: string[];
  priceYearName: string;
  priceYearValue: string;
  priceYearPoints: string[];
  choosePlan: string;
  pricingInWorkspaceTitle: string;
  pricingInWorkspaceDesc: string;
  planMonthlyLabel: string;
  planYearlyLabel: string;
  planSaveHint: string;
  personalPlanName: string;
  personalMonthly: string;
  personalYearly: string;
  personalFeatures: string[];
  proPlanName: string;
  proMonthly: string;
  proYearly: string;
  proFeatures: string[];
  enterprisePlanName: string;
  enterpriseMonthly: string;
  enterpriseYearly: string;
  enterpriseFeatures: string[];
  currentPlanTag: string;
  upgradePricingCardTitle: string;
  upgradeBetaBanner: string;
  upgradeBetaModalTitle: string;
  upgradeBetaModalBody: string;
  upgradeBetaModalOk: string;
  upgradeFreeYouAreOn: string;
  upgradeFreeTierCaption: string;
  enterpriseIncludesProRow: string;
  profileTitle: string;
  profileAccount: string;
  profileRole: string;
  profileSubscription: string;
  profileRenewDate: string;
  dashboardTitle: string;
  dashboardDesc: string;
  dashboardMyAccount: string;
  dashboardAccountUnavailable: string;
  dashboardFieldRole: string;
  dashboardUserId: string;
  statTodayScans: string;
  statRiskBlocks: string;
  statAvgScore: string;
  dashboardUsageMeterApi: string;
  dashboardUsageMeterQuota: string;
  dashboardUsageMeterGeneric: string;
  dashboardUsageMeterHintApi: string;
  dashboardUsageMeterHintQuota: string;
  dashboardUsageMeterHintNone: string;
  recentTitle: string;
  recentColumns: string[];
  recentRows: Array<[string, string, string, string]>;
  billingTitle: string;
  billingDesc: string;
  billingCurrentPlan: string;
  billingRenewDate: string;
  billingUsage: string;
  billingHistoryTitle: string;
  billingHistoryColumns: string[];
  billingRows: Array<[string, string, string, string]>;
  billingAction: string;
  feedbackTitle: string;
  feedbackDesc: string;
  feedbackContactLabel: string;
  feedbackContactPlaceholder: string;
  feedbackQuestionLabel: string;
  feedbackQuestionPlaceholder: string;
  feedbackSubmit: string;
  feedbackSubmitSuccess: string;
  feedbackHistoryTitle: string;
  feedbackColCreated: string;
  feedbackColContact: string;
  feedbackColQuestion: string;
  feedbackColStatus: string;
  feedbackStatusOpen: string;
  feedbackStatusReviewing: string;
  feedbackStatusResolved: string;
  feedbackEmpty: string;
  backToHome: string;
  loginTitle: string;
  loginDesc: string;
  loginEmail: string;
  loginPassword: string;
  loginConfirmPassword: string;
  loginCode: string;
  loginTabSignIn: string;
  loginTabSignUp: string;
  sendCode: string;
  resendIn: string;
  codeSent: string;
  registerButton: string;
  passwordRuleHint: string;
  loginRemember: string;
  loginButton: string;
  loginForgot: string;
  loginByGoogle: string;
  loginByAmazon: string;
  loginNoAccount: string;
  loginCreate: string;
  loginEmailOnlyNote: string;
  langSwitch: string;
  /** 浏览器标签页与 SEO 的 document title */
  seoDocumentTitle: string;
  /** meta description、og:description、twitter:description */
  seoMetaDescription: string;
  /** meta keywords（权重有限，供部分爬虫参考） */
  seoKeywords: string;
  /** og:site_name、Publisher 等 */
  seoOgSiteName: string;
  /** og:image:alt、twitter:image:alt */
  seoOgImageAlt: string;
  /** JSON-LD SoftwareApplication.featureList */
  seoSchemaFeatures: string[];
};

export const textMap: Record<Language, TextSchema> = {
  zh: {
    productName: "US合规盾",
    navHome: "首页",
    navBilling: "账单",
    navDashboard: "仪表盘",
    navWorkspace: "用户后台",
    navStudio: "Studio（Pro）",
    navEnterStudio: "进入 Studio",
    studioBackToWorkspace: "返回工作台",
    studioBackToChat: "返回聊天",
    studioNavNewScan: "发起扫描",
    studioNavRecords: "扫描记录",
    studioBrandSub: "企业合规工作台",
    studioTopbarScansRemainingTpl: "还可扫描 {n} 次",
    studioTopbarScansUnlimited: "不限次数",
    studioCrumbScan: "发起扫描",
    studioCrumbRecords: "扫描记录",
    studioCrumbDetail: "扫描详情",
    studioCrumbMonitoring: "监控和报警",
    studioNavMonitoring: "监控和报警",
    studioNavCompare: "版本对比",
    studioCrumbCompare: "版本对比",
    studioCompareTitle: "历史版本对比",
    studioCompareSubtitleNone: "选择系列后，可对比该系列下多次扫描的差异。",
    studioCompareSubtitleSeriesTpl: "系列「{series}」",
    studioCompareDateFrom: "开始日期",
    studioCompareDateTo: "结束日期",
    studioCompareRisk: "风险等级",
    studioCompareRiskAll: "全部",
    studioCompareRiskHigh: "高",
    studioCompareRiskMed: "中",
    studioCompareRiskLow: "低",
    studioCompareSeries: "系列",
    studioCompareSeriesPh: "选择或搜索系列",
    studioCompareApply: "应用筛选",
    studioComparePickSeries: "请先在上方选择一个系列。",
    studioCompareNoRows: "该系列下暂无符合条件的扫描记录。",
    studioCompareVersionA: "版本 A（较早）",
    studioCompareVersionB: "版本 B（较新）",
    studioComparePickOlder: "请选择较早版本",
    studioComparePickNewer: "请选择较新版本",
    studioCompareRiskScore: "合规分",
    studioCompareFlaggedCountTpl: "高/中风险条数：{n}",
    studioCompareNoFindings: "未发现需关注项。",
    studioCompareSelectTwo: "请在下方列表中勾选两次扫描以进行对比。",
    studioCompareResolvedNTpl: "已消除 {n} 项",
    studioCompareNewNTpl: "新增风险 {n} 项",
    studioCompareCurrentScore: "当前得分",
    studioCompareFlaggedCountBTpl: "仍存高/中风险：{n}",
    studioCompareFixedPrefix: "已修复 · ",
    studioCompareNoDelta: "两版之间无新增或消除的风险项。",
    studioCompareScoreProgress: "得分变化",
    studioCompareGrowth: "环比得分变化",
    studioCompareInsight: "解读",
    studioCompareInsightBodyTpl:
      "相较于较早版本，已消除 {resolved} 项问题，新增 {newRisks} 项风险；当前合规分为 {score}。",
    studioCompareInsightEmpty: "选择两个版本后即可查看差异解读。",
    studioCompareExportDelta: "导出差异 JSON",
    studioCompareTimeline: "版本时间线",
    studioComparePlanned: "计划中",
    studioComparePlannedHint: "下次扫描将出现在这里",
    studioCompareLogs: "扫描记录表",
    studioCompareLogsLead:
      "先在此勾选两次扫描，上方 A/B 对比区会显示差异；导出与解读依赖所选版本。",
    studioCompareColVersion: "版本",
    studioCompareColCompare: "对比",
    studioCompareBadgeNew: "新增",
    studioCompareExportJsonOk: "已导出对比 JSON",
    studioCompareExportLogsOk: "已导出列表",
    studioMonGenReport: "生成报告",
    studioMonPrefsTitle: "提醒设置",
    studioMonPrefsLead: "配置监管情报的接收方式与频率。",
    studioMonMasterLabel: "开启监控提醒",
    studioMonMasterHint: "关闭后将不再推送监管动态。",
    studioMonEmailLabel: "通知邮箱",
    studioMonFreqLabel: "发送频率",
    studioMonFreqRealtime: "实时",
    studioMonFreqDigest: "每日摘要",
    studioMonTopicsLabel: "监控主题",
    studioMonTopicsMax: "最多 12 个",
    studioMonTopicsHint:
      "下列主题为关键词规则：系统在公开监管摘要的标题/正文中匹配英文或中文词（如防晒、益生菌、FTC 等），并非绑定您扫描任务里的 SKU。",
    studioMonAddTopic: "添加主题",
    studioMonAddCustomTopic: "自定义主题",
    studioMonTopicsLoadFailed: "监控主题列表加载失败，请检查网络或登录状态。",
    studioMonPickTopicModalTitle: "选择要添加的监控主题",
    studioMonPickTopicEmpty: "已添加全部可用主题。",
    studioMonCustomTopicModalTitle: "新建自定义监控主题",
    studioMonCustomLabelZh: "显示名称（中文）",
    studioMonCustomLabelEn: "显示名称（英文）",
    studioMonCustomKeywords: "匹配关键词",
    studioMonCustomKeywordsPh:
      "每行一个，或英文逗号分隔；用于在公开监管标题/摘要中匹配",
    studioMonCustomSubmit: "创建",
    studioMonCustomCancel: "取消",
    studioMonCustomCreated:
      "已创建自定义主题，请记得点击「保存设置」同步提醒订阅。",
    studioMonUserTopicDeleted: "已删除自定义主题。",
    studioMonSavePrefs: "保存设置",
    studioMonSignalsTitle: "最新监管信号",
    studioMonSignalsSubtitle:
      "按左侧主题关键词 + 下方来源与搜索筛选后的公开记录。",
    studioMonSignalsExplain:
      "FDA 执法类数据无单独「产品」字段：涉事产品描述通常在标题里；FTC 多为新闻稿标题与摘要。请结合摘要与来源链接阅读。若四个主题全选，则不在此步按主题缩小范围。",
    studioMonSourceAll: "全部来源",
    studioMonKeywordPlaceholder: "按产品名、品牌或成分等搜索（可选）",
    studioMonApplySearch: "筛选",
    studioMonTestNotify: "测试通知",
    studioMonAnalyzeImpact: "分析影响",
    studioMonSourceFda: "FDA",
    studioMonSourceFtc: "FTC",
    studioMonSourceRss: "RSS",
    studioMonStatusHighMatch: "高匹配",
    studioMonStatusDirect: "直接信号",
    studioMonStatusInfo: "资讯",
    studioMonSig1Time: "2023年10月24日 09:42",
    studioMonSig1Title: "新膳食成分通报程序与时限草案指南",
    studioMonSig1Desc:
      "FDA 发布修订草案，说明向 FDA 提交新膳食成分（NDI）通报的程序与时限。",
    studioMonSig1T1: "益生菌",
    studioMonSig1T2: "膳食补充剂",
    studioMonSig2Time: "2023年10月23日 14:15",
    studioMonSig2Title: "关于「消极选项」营销的执法政策声明",
    studioMonSig2Desc:
      "FTC 就健康类订阅服务的披露与取消要求向营销方发出明确警示。",
    studioMonSig2T1: "健康宣称",
    studioMonSig2T2: "电商",
    studioMonSig3Time: "2023年10月22日 11:00",
    studioMonSig3Title: "喷雾防晒中苯含量标注的拟议变更",
    studioMonSig3Desc:
      "行业请愿建议更新 SPF50+ 喷雾制剂中苯杂质检测相关标注与测试方法。",
    studioMonSig3T1: "防晒",
    studioMonSig3T2: "非处方药",
    studioMonTopicSunscreen: "防晒",
    studioMonTopicProbiotics: "益生菌",
    studioMonTopicFtcClaims: "FTC 健康宣称",
    studioMonTopicOtc: "非处方药",
    studioMonSignalsEmpty: "暂无监管信号。请确认已执行数据库种子并启动后端。",
    studioMonSignalsLoadFailed: "监管信号加载失败，请检查网络或登录状态。",
    studioMonSubscriptionLoadFailed: "提醒设置加载失败。",
    studioMonPrefsSaved: "已保存提醒设置",
    studioMonPrefsSaveFailed: "保存失败，请稍后重试。",
    studioDetailBack: "返回",
    studioDetailFinalizeReport: "定稿报告",
    studioDetailFinalizeAgain: "再次导出定稿",
    studioDetailFinalizeConfirmTitle: "确认定稿？",
    studioDetailFinalizeConfirmBody:
      "将下载 JSON 格式的合规审查快照（得分、发现项、改写建议等），并在本机浏览器标记本条扫描为已定稿。可随时再次导出。",
    studioDetailFinalizeOk: "定稿并下载",
    studioDetailFinalizeCancel: "取消",
    studioDetailFinalizeSuccess: "已定稿，报告已下载",
    studioDetailFinalizeFailed: "未能更新本机记录，请重试",
    studioDetailExportPdf: "导出 PDF",
    studioExportPdfTitle: "导出 PDF 选项",
    studioExportPdfCoverLine1: "包含封面",
    studioExportPdfCoverLine2: "在首页展示报告标题、时间与风险概览",
    studioExportPdfLogoLine1: "公司 Logo",
    studioExportPdfLogoLine2: "PNG 或 JPG，显示于封面（可选）",
    studioExportPdfUploadHint: "点击或拖拽上传图片（PNG、JPG）",
    studioExportPdfDisclaimer:
      "免责声明：本报告由 XTool AI 生成，仅供参考，不构成专业法律建议。",
    studioExportPdfGenerate: "生成报告",
    studioExportPdfCancel: "取消",
    studioExportPdfPreview: "实时预览",
    studioExportPdfZoom: "预览缩放",
    studioExportPdfZoomIn: "放大",
    studioExportPdfZoomOut: "缩小",
    studioExportPdfZoomReset: "重置",
    studioExportPdfLogoInvalidType: "请上传 PNG 或 JPG 图片",
    studioExportPdfLogoUploadOk: "Logo 已上传",
    studioExportPdfLogoRemove: "移除",
    studioExportPdfGenerating: "正在生成 PDF…",
    studioExportPdfDownloadOk: "PDF 已下载",
    studioExportPdfDownloadFailed: "生成 PDF 失败，请重试",
    studioPdfReportTitle: "产品合规扫描报告",
    studioPdfSummaryTitle: "摘要",
    studioPdfFindingsTitle: "标记项与风险说明",
    studioPdfRegsTitle: "法规与依据摘录",
    studioPdfAppendixTitle: "本次扫描原文",
    studioPdfReportId: "报告编号",
    studioPdfGeneratedDate: "生成时间",
    studioPdfCategory: "品类",
    studioPdfSkuRef: "SKU / 参考",
    studioPdfCompany: "公司",
    studioPdfSummaryAssessment: "综合评估",
    studioPdfOverallRiskPrefix: "综合风险等级",
    studioPdfCoverDisclaimer:
      "本报告由自动化合规扫描生成，不构成法律意见；上市前请由法律顾问核实。",
    studioPdfComplianceScore: "合规得分",
    studioPdfAnalysisScope: "分析范围",
    studioPdfTargetMarket: "目标市场",
    studioPdfChannel: "渠道",
    studioPdfWordCount: "字数",
    studioPdfProductType: "产品类型",
    studioPdfRiskStats: "风险统计",
    studioPdfRiskHigh: "高风险",
    studioPdfRiskMed: "中风险",
    studioPdfRiskLow: "低风险",
    studioPdfExecSummary: "评估摘要",
    studioPdfColPhrase: "原文片段",
    studioPdfColRisk: "风险等级",
    studioPdfColReason: "违规原因",
    studioPdfColSuggest: "修改建议",
    studioPdfImpact: "要点",
    studioPdfDefaultMarket: "美国（FDA / FTC）",
    studioPdfDefaultChannel: "电商 / D2C",
    studioPdfBrandSentinel: "Compliance Sentinel",
    studioPdfNoFlagged: "未标记片段。",
    studioPdfNoSummary: "无摘要。",
    studioPdfNoClaims: "（无原文）",
    studioPdfRiskCritical: "严重",
    studioPdfRiskWarning: "警告",
    studioPdfRiskObservation: "提示",
    studioPdfRegMatchTitle: "法规关联",
    studioPdfRegEvidenceImpact:
      "引用 FDA（openFDA）与 FTC（RSS）等公开数据作证据提示；下列为与本次宣称相关的命中摘要，数据源持续扩充。",
    studioPdfRegEx1Title: "FD&C Act — 化妆品定义（节选）",
    studioPdfRegEx1Body:
      "「化妆品」指用于人体清洁、美化、增加吸引力或改变外观的物品……治疗类宣称可能将产品划入药品监管。",
    studioPdfRegEx1Impact: "治疗/治愈类表述易触发「药品化」认定。",
    studioPdfRegEx2Title: "FTC 欺骗性表述原则（节选）",
    studioPdfRegEx2Body:
      "若表述可能误导消费者且对购买决策有实质性影响，则可能被认定为欺骗性宣传。",
    studioPdfRegEx2Impact: "未经充分证实的「临床证明」等表述风险较高。",
    studioPdfRegEx3Title: "OTC 防晒专论（示意）",
    studioPdfRegEx3Body:
      "SPF 标识与测试方法须符合专论要求；即时防护等表述需与标签规则一致。",
    studioPdfRegEx3Impact: "防晒类宣称建议对照现行专论与标签指南。",
    studioRecordsTitle: "扫描记录",
    studioRecordsEmpty:
      "完成扫描后记录会保存在本机浏览器，可在此查看并打开与结果详情页相同的发现表。",
    studioRecordsNoData: "暂无数据",
    studioRecordsColWhen: "时间",
    studioRecordsColProduct: "产品 / 内部名称",
    studioRecordsColId: "扫描 ID",
    studioRecordsColScore: "合规分",
    studioRecordsColRisk: "风险",
    studioRecordsActionDetail: "详情",
    studioRecordsRiskHigh: "高风险",
    studioRecordsRiskMed: "中风险",
    studioRecordsRiskLow: "低风险",
    studioRecordsHeadline: "扫描记录",
    studioRecordsBcRoot: "工作台",
    studioRecordsSyncLine: "扫描记录已保存至服务器（按账号），换设备登录同一账号可查看。",
    studioRecordsExportAll: "导出全部",
    studioRecordsSearchPh: "搜索产品名称或扫描 ID…",
    studioRecordsFilters: "筛选",
    studioRecordsRiskLevelLabel: "风险等级",
    studioRecordsPillHigh: "高风险",
    studioRecordsPillMedium: "中风险",
    studioRecordsPillLow: "低风险",
    studioRecordsThTime: "时间",
    studioRecordsThProduct: "产品名称",
    studioRecordsThScanId: "扫描 ID",
    studioRecordsThCompliance: "合规得分",
    studioRecordsThRiskTag: "风险标签",
    studioRecordsThActions: "操作",
    studioRecordsViewDetail: "查看详情",
    studioRecordsTagCritical: "严重",
    studioRecordsTagHighRisk: "高风险",
    studioRecordsTagMedium: "中风险",
    studioRecordsTagSecure: "合规",
    studioRecordsBatchTitle: "批量分析报告",
    studioRecordsBatchDesc:
      "基于最近 50 次扫描生成整体风险概览，识别系统性薄弱点。",
    studioRecordsBatchCta: "生成摘要",
    studioRecordsHealthTitle: "健康度",
    studioRecordsHealthDesc:
      "工作区扫描合规状态良好。4 个产品共 12 项待处理动作。",
    studioComingShort: "即将推出",
    studioMonTopicsAllAdded: "已添加全部可用主题",
    studioMonTestNotifySent: "已发送测试通知",
    studioMonTestNotifyDenied: "未授予通知权限，请在浏览器设置中允许本站通知",
    studioMonTestNotifyUnsupported: "当前浏览器不支持系统通知",
    studioMonExportReportOk: "已导出当前信号列表（JSON）",
    studioRecordsExported: "已导出扫描记录（JSON）",
    studioRecordsBatchSummaryOk: "已生成并下载批量摘要（TXT）",
    studioDetailDisclaimerCopied: "免责声明草稿已复制到剪贴板",
    studioDetailDisclaimerCopyFailed: "复制失败，请手动选择文本",
    studioDetailCompareAdded: "已加入对比集并打开记录列表",
    sheCompareNeedScanFirst: "请先完成至少一次扫描后再使用对比功能",
    sheNoScansTitle: "尚无扫描记录",
    sheNoScansLead: "开始您的第一次合规评估，识别产品宣称中的监管风险与差距。",
    sheNoScansLeadSub: "",
    sheRunFirstScan: "运行首次扫描",
    sheCompareBadge: "对比工具",
    sheCompareTitle: "比较扫描结果",
    sheCompareDesc:
      "从历史记录中选择两次扫描，对比已解决与新增风险，跟踪监管周期内的变化。",
    sheCompareDescSub: "",
    sheSelectHistory: "选择历史",
    sheAlertsTitle: "警报已禁用",
    sheAlertsDesc:
      "启用警报以监控您关注类别的监管更新，及时了解标签与宣称规则变化。",
    sheAlertsDescSub: "",
    sheConfigureAlerts: "配置警报",
    studioFormTitle: "新建合规分析",
    studioFormSubtitle:
      "对照监管框架校验营销宣称。步骤 1/1：配置与输入（非对话模式，仅结构化扫描）。",
    studioMetaTitle: "扫描元数据",
    studioInternalName: "产品名称",
    studioInternalNamePh:
      "将写入扫描记录列表；可与内部 SKU 一致，例如 VC-SERUM-01",
    studioVerticalLabel: "产品类别",
    studioVerticalCosmetic: "化妆品",
    studioVerticalFood: "食品",
    studioVerticalSupplement: "保健品",
    studioVerticalBaby: "婴童用品",
    studioClaimsTitle: "分析文本（宣称正文）",
    studioClaimsHint: "粘贴原始产品文案、包装用语或营销宣称。",
    studioClaimsPh: "在此粘贴待分析的宣称全文…",
    studioOptionsTitle: "分析选项",
    studioOptFda: "包含 FDA 证据块",
    studioOptFdaDesc:
      "引用 FDA 公开执法数据（openFDA 同步）及 FTC 新闻稿（官方 RSS）作证据提示；数据源持续扩充。",
    studioOptSeries: "关联系列以便版本对比",
    studioOptSeriesDesc: "将本次扫描写入所选系列，便于与同产品线历史版本对照。",
    studioSeriesLabel: "目标系列",
    studioSeriesPlaceholder: "选择系列",
    studioSeriesNewBtn: "新建系列",
    studioSeriesCreateModalTitle: "新建系列",
    studioSeriesNamePh: "例如：SPF50 防晒霜 V 系列",
    studioSeriesCreateSuccess: "已创建系列",
    studioSeriesNeedSelect: "请先选择或新建一个系列",
    studioSeriesNameRequired: "请输入系列名称",
    studioSeriesLoadFailed: "系列列表加载失败，请检查登录与网络",
    studioSeriesSyncFailed:
      "系列已保存在本机记录；同步到服务端失败，请检查登录与网络后重试。",
    studioSaveDraft: "保存草稿",
    studioRunScan: "运行扫描",
    studioScanning: "正在扫描…",
    studioEstTime: "预估：约每千字 45 秒级处理（视后端而定）。",
    studioRiskPanelTitle: "将检查的风险类别",
    studioRiskDisease: "疾病治疗宣称",
    studioRiskAdditive: "未批准添加物暗示",
    studioRiskIngredient: "成分违规",
    studioRiskComparative: "对比/优效宣称",
    studioRiskEco: "环保可持续表述",
    studioAuditTitle: "审计说明",
    studioAuditBody:
      "扫描由 XTool 分析引擎执行，结果仅供决策参考，不构成法律意见。",
    studioNeedHelpTitle: "需要帮助？",
    studioNeedHelpBody: "查看基于结构/功能宣称的撰写指南以提高通过率。",
    studioDocLink: "文档",
    studioDetailTitle: "扫描结果详情",
    studioContinueScan: "继续扫描",
    studioNoClaims: "请先输入待分析的宣称文本。",
    studioScanFailed: "扫描失败",
    studioFdaEvidence: "监管证据命中",
    navFeedback: "问题反馈",
    headerBadge: "FDA 规则已更新",
    loginEntry: "登录",
    logoutEntry: "退出登录",
    userMenuConsoleOverview: "进入后台总览",
    openConsole: "进入后台",
    heroTitle: "美国市场合规上线助手",
    slogan: "化妆品 / 保健品宣称审查工具",
    subtitle: "上传产品文案，AI 告诉你哪里违规、为什么违规、怎么改。",
    heroPrimaryAction: "开始对话审查",
    heroSecondaryAction: "查看工作台",
    heroHighlights: ["AI 合规对话审查", "中英文文案支持", "FDA 风险规则联动"],
    heroStatScans: "累计扫描 120K+",
    heroStatAccuracy: "风险命中率 94.2%",
    heroStatUpdates: "规则更新频率：日级",
    heroFlowTitle: "使用流程",
    heroFlows: [
      "1. 进入对话并粘贴文案",
      "2. 自动识别高风险宣称",
      "3. 获得可直接替换的改写建议",
    ],
    authorityTitle: "FDA / FTC 公开数据证据提示（持续更新）",
    authorityDesc:
      "引用 FDA 公开执法数据（openFDA 同步）及 FTC 等相关公开记录作证据提示，并结合关键词规则与模型审查；数据源持续扩充。",
    authorityItems: [
      "覆盖化妆品与膳食补充剂高风险宣称",
      "优先拦截疾病治疗、治愈、药品化表达",
      "输出可落地的替换建议与风险解释",
    ],
    ruleVersionLabel: "规则版本",
    ruleVersionValue: "FDA-2026.03",
    lastSyncLabel: "最近同步",
    sourceLabel: "数据来源",
    sourceValue: "FDA（openFDA）+ FTC（RSS），持续扩充数据源",
    fdaStatusLabel: "FDA 接口状态",
    fdaStatusOnline: "在线",
    fdaStatusOffline: "离线",
    loginRequiredTitle: "需要先登录",
    loginRequiredDesc: "开始对话审查前，请先登录账号。",
    loginNow: "去登录",
    sessionExpiredTitle: "登录已失效",
    sessionExpiredDesc: "登录状态已过期或无效，请重新登录后再试。",
    sessionExpiredGoLogin: "去登录",
    later: "稍后再说",
    focusTitle: "本期审查重点",
    focusDesc: "优先处理易触发执法关注的高风险表达，先拦截再优化转化。",
    focusItems: [
      "疾病治疗/治愈承诺",
      "见效时限承诺（7天见效）",
      "药品化词汇（治愈、处方级）",
    ],
    productFocusTitle: "重点审查产品类型",
    productFocusItems: [
      "膳食补充剂：睡眠、减肥、控糖、护肝类",
      "功能护肤品：祛痘、修复、抗炎、抗敏类",
      "跨境热销爆款：夸张疗效词密集使用的商品",
    ],
    claimFocusTitle: "重点审查宣称",
    claimFocusItems: [
      "Treat / Cure / Diagnose / 治疗 / 治愈 / 根治",
      "Guaranteed / 100% effective / 立即见效",
      "类似药品作用机制但缺乏合规证据的表达",
    ],
    scanInputTitle: "文案扫描",
    chatHistoryTitle: "历史会话",
    newChat: "新建会话",
    assistantWelcome:
      "你好，我是 US 合规盾助手。发送一段文案，我会给你风险说明和改写建议。",
    chatInputPlaceholder:
      "输入产品宣称内容，例如：本产品可治疗失眠，7天见效...",
    sendMessage: "发送",
    executeReview: "执行合规审查",
    scanToolkitEntry: "进入 Studio 模式",
    scanToolkitShort: "Studio",
    scanToolkitProTag: "Pro",
    scanToolkitLockedTitle: "需要 Pro 或 Enterprise",
    scanToolkitLockedBody:
      "升级后可使用 Studio（Pro）：PDF 报告、历史版本对比、法规订阅等能力。",
    complianceHubTitle: "Studio",
    complianceHubLead:
      "Studio 是 XTool 的专业版扫描工作台，与聊天内「执行合规审查」配合使用；以下模块将按开发进度陆续接入后端。",
    complianceHubPdfTitle: "合规 PDF 报告",
    complianceHubPdfDesc:
      "一键导出带封面与法规引用的报告，支持企业 Logo（付费权益）。",
    complianceHubCompareTitle: "历史版本对比",
    complianceHubCompareDesc: "同一文案多轮扫描对比，高亮已修复项与新增风险。",
    complianceHubAlertsTitle: "法规更新订阅",
    complianceHubAlertsDesc: "按关注品类推送 FDA/FTC 等更新摘要与检查建议。",
    complianceHubLockedTitle: "Studio 仅限 Pro / Enterprise",
    complianceHubLockedLead: "升级套餐后即可使用 Studio（Pro）扫描。",
    reviewCosts: "消耗 1 次审查额度",
    chatModeHint: "普通对话免费；执行合规审查才会扣减额度。",
    creditsLabel: "剩余审查额度",
    currentPlanLabel: "当前套餐",
    freeChatReply:
      "这是普通对话建议：我可以继续帮你润色表达与结构。若要获取 FDA 风险分、违规原因和可直接替换的改写，请点击“执行合规审查”。",
    reviewUpsell:
      "合规结论属于付费审查结果，建议执行一次审查任务获取可落地输出。",
    outOfCredits: "审查额度不足，请升级套餐或购买更多额度。",
    upgradePlanNow: "去升级套餐",
    scanningReply: "正在分析中...",
    scanInputPlaceholder:
      "请输入或粘贴产品文案。例如：本产品可治疗失眠、改善焦虑，7天见效...",
    uploadLabel: "支持上传文本（MVP 先用粘贴输入）",
    uploadButton: "上传文案",
    scanButton: "开始合规扫描",
    scanning: "正在扫描...",
    resultTitle: "合规分析结果",
    scoreLabel: "合规分",
    riskLevel: "风险等级",
    phrase: "风险片段",
    reason: "违规原因",
    suggestion: "修改建议",
    emptyResult: "先输入文案并点击扫描，结果会显示在这里。",
    pricingTitle: "MVP 定价",
    pricingFree: "免费体验：3次扫描",
    pricingOneTime: "单次扫描：$9.9",
    pricingMonth: "月订阅：$49（10次）",
    pricingYear: "年订阅：$399（不限次）",
    targetUsersTitle: "目标用户",
    targetUsers: [
      "亚马逊 / 独立站卖家（化妆品、保健品）",
      "跨境电商运营 / 文案",
      "品牌出海市场人员",
    ],
    fdaTitle: "FDA / FTC 公开监管数据",
    fdaDesc:
      "引用 FDA 公开执法数据（openFDA 同步）及 FTC 新闻稿（官方 RSS）作证据提示，持续扩充数据源。",
    fdaButton: "测试 FDA 接口连通性",
    fdaOk: "FDA 接口可访问",
    fdaFail: "FDA 接口不可访问，稍后再试",
    pricingHeroTitle: "灵活定价，覆盖从试用到规模化团队",
    pricingHeroDesc: "按扫描次数或订阅付费，适合个人卖家、运营团队和品牌公司。",
    pricingFeatureTitle: "核心能力",
    pricingFeatures: [
      "AI 风险标记 + 可解释原因",
      "支持中英文文案扫描",
      "FDA（openFDA）+ FTC（RSS）公开数据证据提示，持续扩充数据源",
      "操作留痕与团队协作接口（预留）",
    ],
    priceFreeName: "免费体验",
    priceFreeValue: "$0",
    priceFreePoints: ["3 次扫描", "基础风险提示", "社区支持"],
    priceSingleName: "单次扫描",
    priceSingleValue: "$9.9",
    priceSinglePoints: ["1 次深度扫描", "风险片段定位", "建议改写"],
    priceMonthName: "月订阅",
    priceMonthValue: "$49",
    priceMonthPoints: ["10 次扫描", "历史记录", "优先客服支持"],
    priceYearName: "年订阅",
    priceYearValue: "$399",
    priceYearPoints: ["不限次扫描", "团队席位", "API 优先接入"],
    choosePlan: "选择该方案",
    pricingInWorkspaceTitle: "订阅套餐",
    pricingInWorkspaceDesc: "支持月付与年付，年付约优惠 15%。",
    planMonthlyLabel: "月付",
    planYearlyLabel: "年付",
    planSaveHint: "年付立减约 10%-20%",
    personalPlanName: "Personal",
    personalMonthly: "$20 /月 · 30次扫描",
    personalYearly: "$204 /年 · 360次扫描",
    personalFeatures: ["适合个人运营", "基础模型审查", "邮件支持"],
    proPlanName: "Pro",
    proMonthly: "$40 /月 · 70次扫描",
    proYearly: "$408 /年 · 840次扫描",
    proFeatures: [
      "专业工作台 Studio：独立扫描、扫描记录与法规监控等 Pro 能力",
      "适合小团队",
      "优先审查队列",
      "多版本改写建议",
    ],
    enterprisePlanName: "Enterprise",
    enterpriseMonthly: "$99 /月 · 不限扫描",
    enterpriseYearly: "$999 /年 · 不限扫描",
    enterpriseFeatures: [
      "包含 Pro 全部功能",
      "企业合规策略与自定义规则",
      "API 接入",
      "专属客户成功经理",
    ],
    currentPlanTag: "当前订阅",
    upgradePricingCardTitle: "全部定价",
    upgradeBetaBanner:
      "正在公测阶段，暂不支持在线升级套餐。以下为各档参考定价，正式开放购买时将另行通知。",
    upgradeBetaModalTitle: "暂不支持升级",
    upgradeBetaModalBody: "正在公测阶段，暂不支持升级计划。请关注后续公告。",
    upgradeBetaModalOk: "知道了",
    upgradeFreeYouAreOn: "您当前为免费方案",
    upgradeFreeTierCaption: "基础免费档（入门额度与基础能力）",
    enterpriseIncludesProRow: "包含专业版（Pro）全部功能",
    profileTitle: "个人资料",
    profileAccount: "账号：ops@brand.com",
    profileRole: "角色：Owner",
    profileSubscription: "订阅：Pro Annual",
    profileRenewDate: "续费日：2026-04-21",
    dashboardTitle: "运营总览",
    dashboardDesc: "聚焦高风险宣称，跟踪扫描表现与合规趋势。",
    dashboardMyAccount: "我的账号",
    dashboardAccountUnavailable: "未能加载账号信息",
    dashboardFieldRole: "角色",
    dashboardUserId: "用户 ID",
    statTodayScans: "今日扫描",
    statRiskBlocks: "已拦截高风险",
    statAvgScore: "平均合规分",
    dashboardUsageMeterApi: "API 额度占用",
    dashboardUsageMeterQuota: "本月扫描配额",
    dashboardUsageMeterGeneric: "用量占比",
    dashboardUsageMeterHintApi:
      "相对当前套餐 API 限额的已用比例（0–100%），不是账户里的审查积分余额。",
    dashboardUsageMeterHintQuota:
      "本月已用扫描次数 ÷ 套餐月配额。与「审查额度/积分」余额不同，余额请见账单或扫描页。",
    dashboardUsageMeterHintNone: "后端未返回用量数据时显示为 0%。",
    recentTitle: "最近扫描记录",
    recentColumns: ["时间", "产品", "风险等级", "状态"],

    recentRows: [
      ["15:20", "睡眠软糖文案", "高", "已建议改写"],
      ["14:05", "祛痘精华详情页", "中", "已通过"],
      ["10:43", "护肝胶囊广告语", "高", "待处理"],
    ],

    billingTitle: "账单与订阅",
    billingDesc: "查看当前套餐、用量与付款记录，支持随时升级或切换套餐。",
    billingCurrentPlan: "当前方案：月订阅 $49",
    billingRenewDate: "下次扣费：2026-04-21",
    billingUsage: "本月用量：6 / 10 次扫描",
    billingHistoryTitle: "支付记录",
    billingHistoryColumns: ["日期", "项目", "金额", "状态"],
    billingRows: [
      ["2026-03-21", "月订阅", "$49", "已支付"],
      ["2026-02-21", "月订阅", "$49", "已支付"],
      ["2026-02-02", "单次扫描", "$9.9", "已支付"],
    ],
    billingAction: "管理支付方式",
    feedbackTitle: "问题反馈",
    feedbackDesc: "留下你的联系方式和问题描述，我们会跟进处理。",
    feedbackContactLabel: "联系方式",
    feedbackContactPlaceholder: "请输入邮箱",
    feedbackQuestionLabel: "问题描述",
    feedbackQuestionPlaceholder: "请输入你遇到的问题说明或复现步骤",
    feedbackSubmit: "提交反馈",
    feedbackSubmitSuccess: "反馈已提交，我们会尽快联系你。",
    feedbackHistoryTitle: "反馈记录",
    feedbackColCreated: "提交时间",
    feedbackColContact: "联系方式",
    feedbackColQuestion: "问题",
    feedbackColStatus: "状态",
    feedbackStatusOpen: "待处理",
    feedbackStatusReviewing: "处理中",
    feedbackStatusResolved: "已解决",
    feedbackEmpty: "暂无反馈记录",
    backToHome: "返回首页",
    loginTitle: "登录你的合规工作台",
    loginDesc: "统一管理文案风险、扫描记录与改写版本，提升上架效率。",
    loginEmail: "邮箱",
    loginPassword: "密码",
    loginConfirmPassword: "确认密码",
    loginCode: "验证码",
    loginTabSignIn: "登录",
    loginTabSignUp: "注册",
    sendCode: "发送验证码",
    resendIn: "后重发",
    codeSent: "验证码已发送，请检查邮箱（演示）",
    registerButton: "注册并登录",
    passwordRuleHint: "密码至少 8 位，建议包含字母和数字。",
    loginRemember: "记住登录状态",
    loginButton: "登录",
    loginForgot: "忘记密码？",
    loginByGoogle: "使用 Google 登录",
    loginByAmazon: "使用 Amazon 登录",
    loginNoAccount: "还没有账号？",
    loginCreate: "创建账号",
    loginEmailOnlyNote: "登录使用邮箱+密码；注册需要邮箱验证码。",
    langSwitch: "EN",
    seoDocumentTitle: "US合规盾 | XTool",
    seoMetaDescription:
      "US合规盾 — 化妆品与保健品宣称审查工具，帮助面向美国市场的卖家快速完成合规文案扫描与风险识别。",
    seoKeywords:
      "FDA,FTC,合规,化妆品,保健品,宣称审查,美国市场,出海,文案扫描,监管情报,XTool,US合规盾",
    seoOgSiteName: "XTool",
    seoOgImageAlt:
      "XTool US合规盾 — 面向美国市场的化妆品与保健品宣称合规扫描与监管情报工具",
    seoSchemaFeatures: [
      "针对化妆品、膳食补充剂等品类的文案宣称一键扫描与风险分级",
      "结合 FDA、FTC 等公开监管摘要与证据线索，辅助出海卖家自查",
      "Studio：扫描序列管理、PDF 合规报告导出、历史版本对比（Pro）",
      "监控主题与邮件提醒，跟踪与您品类相关的公开监管动态",
      "支持中英文界面，服务跨境与美国本土运营团队",
    ],
  },
  en: {
    productName: "US Compliance Shield",
    navHome: "Home",
    navBilling: "Billing",
    navDashboard: "Dashboard",
    navWorkspace: "Workspace",
    navStudio: "Studio (Pro)",
    navEnterStudio: "Enter Studio",
    studioBackToWorkspace: "Back to workspace",
    studioBackToChat: "Back to chat",
    studioNavNewScan: "New scan",
    studioNavRecords: "Scan records",
    studioBrandSub: "Enterprise compliance",
    studioTopbarScansRemainingTpl: "{n} scans left",
    studioTopbarScansUnlimited: "Unlimited",
    studioCrumbScan: "New scan",
    studioCrumbRecords: "Scan records",
    studioCrumbDetail: "Scan detail",
    studioCrumbMonitoring: "Monitoring & alerts",
    studioNavMonitoring: "Monitoring & alerts",
    studioNavCompare: "Compare versions",
    studioCrumbCompare: "Compare versions",
    studioCompareTitle: "Version history & compare",
    studioCompareSubtitleNone:
      "Pick a series to compare multiple scans side by side.",
    studioCompareSubtitleSeriesTpl: "Series: {series}",
    studioCompareDateFrom: "From date",
    studioCompareDateTo: "To date",
    studioCompareRisk: "Risk level",
    studioCompareRiskAll: "All",
    studioCompareRiskHigh: "High",
    studioCompareRiskMed: "Medium",
    studioCompareRiskLow: "Low",
    studioCompareSeries: "Series",
    studioCompareSeriesPh: "Select or search a series",
    studioCompareApply: "Apply filters",
    studioComparePickSeries: "Select a series above first.",
    studioCompareNoRows: "No scans match the filters for this series.",
    studioCompareVersionA: "Version A (older)",
    studioCompareVersionB: "Version B (newer)",
    studioComparePickOlder: "Pick the older scan",
    studioComparePickNewer: "Pick the newer scan",
    studioCompareRiskScore: "Compliance score",
    studioCompareFlaggedCountTpl: "High/medium findings: {n}",
    studioCompareNoFindings: "No flagged items.",
    studioCompareSelectTwo: "Select two scans in the table below to compare.",
    studioCompareResolvedNTpl: "{n} resolved",
    studioCompareNewNTpl: "{n} new risks",
    studioCompareCurrentScore: "Current score",
    studioCompareFlaggedCountBTpl: "High/medium remaining: {n}",
    studioCompareFixedPrefix: "Fixed · ",
    studioCompareNoDelta:
      "No new or resolved risks between these two versions.",
    studioCompareScoreProgress: "Score progress",
    studioCompareGrowth: "Score change",
    studioCompareInsight: "Insight",
    studioCompareInsightBodyTpl:
      "Versus the older run: {resolved} issue(s) cleared, {newRisks} new risk(s); current score {score}.",
    studioCompareInsightEmpty:
      "Select two versions to see a short narrative summary.",
    studioCompareExportDelta: "Export delta JSON",
    studioCompareTimeline: "Version timeline",
    studioComparePlanned: "Planned",
    studioComparePlannedHint: "Your next scan will appear here",
    studioCompareLogs: "Scan log",
    studioCompareLogsLead:
      "Select two rows below to drive the A/B comparison above; export and insight use your picks.",
    studioCompareColVersion: "Version",
    studioCompareColCompare: "Compare",
    studioCompareBadgeNew: "New",
    studioCompareExportJsonOk: "Exported comparison JSON",
    studioCompareExportLogsOk: "Exported list",
    studioMonGenReport: "Generate report",
    studioMonPrefsTitle: "Alert preferences",
    studioMonPrefsLead:
      "Choose how and when you receive regulatory intelligence.",
    studioMonMasterLabel: "Enable alerts",
    studioMonMasterHint:
      "When off, you will not receive regulatory push updates.",
    studioMonEmailLabel: "Notification email",
    studioMonFreqLabel: "Delivery frequency",
    studioMonFreqRealtime: "Real-time",
    studioMonFreqDigest: "Daily digest",
    studioMonTopicsLabel: "Monitored topics",
    studioMonTopicsMax: "Max 12 topics",
    studioMonTopicsHint:
      "Each topic maps to keyword rules: we match English/Chinese terms in public record titles and summaries (e.g., sunscreen, probiotic, FTC). This is not tied to your scan SKUs.",
    studioMonAddTopic: "Add topic",
    studioMonAddCustomTopic: "Custom topic",
    studioMonTopicsLoadFailed:
      "Could not load monitor topics. Check network or sign in.",
    studioMonPickTopicModalTitle: "Add a monitored topic",
    studioMonPickTopicEmpty: "All available topics are already added.",
    studioMonCustomTopicModalTitle: "Create custom monitor topic",
    studioMonCustomLabelZh: "Label (Chinese)",
    studioMonCustomLabelEn: "Label (English)",
    studioMonCustomKeywords: "Match keywords",
    studioMonCustomKeywordsPh:
      "One per line or comma-separated; matched in public titles/summaries",
    studioMonCustomSubmit: "Create",
    studioMonCustomCancel: "Cancel",
    studioMonCustomCreated:
      "Custom topic created. Click “Save preferences” to sync alert subscription.",
    studioMonUserTopicDeleted: "Custom topic removed.",
    studioMonSavePrefs: "Save preferences",
    studioMonSignalsTitle: "Recent regulatory signals",
    studioMonSignalsSubtitle:
      "Filtered by your topic keywords plus source and search below.",
    studioMonSignalsExplain:
      "FDA enforcement rows have no separate product field: affected product text is usually in the title; FTC items are press titles and blurbs. Read the summary and source link for context. If all four topics are selected, we skip topic narrowing.",
    studioMonSourceAll: "All sources",
    studioMonKeywordPlaceholder:
      "Search product name, brand, or ingredient (optional)",
    studioMonApplySearch: "Apply",
    studioMonTestNotify: "Test notification",
    studioMonAnalyzeImpact: "Analyze impact",
    studioMonSourceFda: "FDA",
    studioMonSourceFtc: "FTC",
    studioMonSourceRss: "RSS feed",
    studioMonStatusHighMatch: "High match",
    studioMonStatusDirect: "Direct signal",
    studioMonStatusInfo: "Informational",
    studioMonSig1Time: "Oct 24, 2023 · 9:42 AM",
    studioMonSig1Title:
      "Draft guidance on new dietary ingredient notification procedures and timeframes",
    studioMonSig1Desc:
      "The FDA issued a revised draft describing procedures for submitting an NDI notification.",
    studioMonSig1T1: "Probiotics",
    studioMonSig1T2: "Dietary supplements",
    studioMonSig2Time: "Oct 23, 2023 · 2:15 PM",
    studioMonSig2Title: "Enforcement policy on negative option marketing",
    studioMonSig2Desc:
      "The FTC warns marketers about disclosure and cancellation rules for recurring health subscriptions.",
    studioMonSig2T1: "Health claims",
    studioMonSig2T2: "E-commerce",
    studioMonSig3Time: "Oct 22, 2023 · 11:00 AM",
    studioMonSig3Title:
      "Proposed labeling changes for benzene in aerosol sunscreens",
    studioMonSig3Desc:
      "Industry petition to update testing protocols for benzene impurities in SPF 50+ aerosols.",
    studioMonSig3T1: "Sunscreen",
    studioMonSig3T2: "OTC drugs",
    studioMonTopicSunscreen: "Sunscreen",
    studioMonTopicProbiotics: "Probiotics",
    studioMonTopicFtcClaims: "FTC health claims",
    studioMonTopicOtc: "OTC drugs",
    studioMonSignalsEmpty:
      "No regulatory signals yet. Run the DB seed and ensure the API is running.",
    studioMonSignalsLoadFailed:
      "Could not load regulatory signals. Check network or sign in.",
    studioMonSubscriptionLoadFailed: "Could not load alert preferences.",
    studioMonPrefsSaved: "Alert preferences saved",
    studioMonPrefsSaveFailed: "Could not save preferences.",
    studioDetailBack: "Back",
    studioDetailFinalizeReport: "Finalize report",
    studioDetailFinalizeAgain: "Export again",
    studioDetailFinalizeConfirmTitle: "Finalize this scan?",
    studioDetailFinalizeConfirmBody:
      "Downloads a JSON compliance snapshot (score, findings, rewrite text) and marks this scan as finalized in this browser. You can export again anytime.",
    studioDetailFinalizeOk: "Finalize & download",
    studioDetailFinalizeCancel: "Cancel",
    studioDetailFinalizeSuccess: "Finalized — report downloaded",
    studioDetailFinalizeFailed: "Could not update local records",
    studioDetailExportPdf: "Export PDF",
    studioExportPdfTitle: "Export PDF options",
    studioExportPdfCoverLine1: "Include cover page",
    studioExportPdfCoverLine2:
      "Shows the report title, timestamps, and risk overview on page 1",
    studioExportPdfLogoLine1: "Company logo",
    studioExportPdfLogoLine2: "PNG or JPG, shown on the cover (optional)",
    studioExportPdfUploadHint: "Click or drag image to upload (PNG, JPG)",
    studioExportPdfDisclaimer:
      "Disclaimer: This report is generated by XTool AI for informational purposes only and does not constitute professional legal advice.",
    studioExportPdfGenerate: "Generate report",
    studioExportPdfCancel: "Cancel",
    studioExportPdfPreview: "Live preview",
    studioExportPdfZoom: "Preview zoom",
    studioExportPdfZoomIn: "Zoom in",
    studioExportPdfZoomOut: "Zoom out",
    studioExportPdfZoomReset: "Reset",
    studioExportPdfLogoInvalidType: "Please upload a PNG or JPG image",
    studioExportPdfLogoUploadOk: "Logo uploaded",
    studioExportPdfLogoRemove: "Remove",
    studioExportPdfGenerating: "Generating PDF…",
    studioExportPdfDownloadOk: "PDF downloaded",
    studioExportPdfDownloadFailed: "Could not generate PDF. Please try again.",
    studioPdfReportTitle: "Product Compliance Scan Report",
    studioPdfSummaryTitle: "Summary",
    studioPdfFindingsTitle: "Flagged Items & Risk Notes",
    studioPdfRegsTitle: "Regulatory References",
    studioPdfAppendixTitle: "Original Scan Text",
    studioPdfReportId: "Report ID",
    studioPdfGeneratedDate: "Generated date",
    studioPdfCategory: "Category",
    studioPdfSkuRef: "SKU / Reference",
    studioPdfCompany: "Company",
    studioPdfSummaryAssessment: "SUMMARY ASSESSMENT",
    studioPdfOverallRiskPrefix: "Overall risk level",
    studioPdfCoverDisclaimer:
      "This report is from an automated scan and is not legal advice. Verify with counsel before submission.",
    studioPdfComplianceScore: "Compliance score",
    studioPdfAnalysisScope: "Analysis scope",
    studioPdfTargetMarket: "Target market",
    studioPdfChannel: "Channel",
    studioPdfWordCount: "Word count",
    studioPdfProductType: "Product type",
    studioPdfRiskStats: "Risk indicators",
    studioPdfRiskHigh: "High risk",
    studioPdfRiskMed: "Medium risk",
    studioPdfRiskLow: "Low risk",
    studioPdfExecSummary: "Executive summary",
    studioPdfColPhrase: "Original phrase",
    studioPdfColRisk: "Risk level",
    studioPdfColReason: "Reason",
    studioPdfColSuggest: "Suggestion",
    studioPdfImpact: "Impact",
    studioPdfDefaultMarket: "United States (FDA / FTC)",
    studioPdfDefaultChannel: "E-commerce / D2C",
    studioPdfBrandSentinel: "Compliance Sentinel",
    studioPdfNoFlagged: "No flagged phrases.",
    studioPdfNoSummary: "No summary.",
    studioPdfNoClaims: "(No source text)",
    studioPdfRiskCritical: "Critical",
    studioPdfRiskWarning: "Warning",
    studioPdfRiskObservation: "Observation",
    studioPdfRegMatchTitle: "Regulatory match",
    studioPdfRegEvidenceImpact:
      "We cite FDA (openFDA) and FTC (RSS) public data as contextual evidence signals; below are matched snippets for this scan. Data sources are continuously expanded.",
    studioPdfRegEx1Title: "FD&C Act — Cosmetic definition (excerpt)",
    studioPdfRegEx1Body:
      "The term 'cosmetic' means articles intended for cleansing, beautifying, or altering appearance… Therapeutic claims may trigger drug regulation.",
    studioPdfRegEx1Impact:
      "Therapeutic language can trigger drug classification.",
    studioPdfRegEx2Title: "FTC Deception Policy (excerpt)",
    studioPdfRegEx2Body:
      "A practice is deceptive if it is likely to mislead and is material to consumers’ decisions.",
    studioPdfRegEx2Impact:
      "Unsubstantiated 'clinically proven' claims carry higher risk.",
    studioPdfRegEx3Title: "OTC sunscreen monograph (illustrative)",
    studioPdfRegEx3Body:
      "SPF labeling must follow monograph testing; 'instant' claims must align with labeling rules.",
    studioPdfRegEx3Impact:
      "Align sunscreen copy with current monograph and labeling.",
    studioRecordsTitle: "Scan records",
    studioRecordsEmpty:
      "After each scan, a row is stored in this browser. Open Detail to see the same findings table as the result view.",
    studioRecordsNoData: "No data",
    studioRecordsColWhen: "Time",
    studioRecordsColProduct: "Product / internal name",
    studioRecordsColId: "Scan ID",
    studioRecordsColScore: "Score",
    studioRecordsColRisk: "Risk",
    studioRecordsActionDetail: "Detail",
    studioRecordsRiskHigh: "High risk",
    studioRecordsRiskMed: "Medium risk",
    studioRecordsRiskLow: "Low risk",
    studioRecordsHeadline: "Scan records",
    studioRecordsBcRoot: "Studio",
    studioRecordsSyncLine:
      "Scan history is saved on the server for your account and available when you sign in elsewhere.",
    studioRecordsExportAll: "Export all",
    studioRecordsSearchPh: "Search product or scan ID…",
    studioRecordsFilters: "Filters",
    studioRecordsRiskLevelLabel: "Risk level",
    studioRecordsPillHigh: "High",
    studioRecordsPillMedium: "Medium",
    studioRecordsPillLow: "Low",
    studioRecordsThTime: "Time",
    studioRecordsThProduct: "Product name",
    studioRecordsThScanId: "Scan ID",
    studioRecordsThCompliance: "Compliance score",
    studioRecordsThRiskTag: "Risk tag",
    studioRecordsThActions: "Actions",
    studioRecordsViewDetail: "View detail",
    studioRecordsTagCritical: "CRITICAL",
    studioRecordsTagHighRisk: "HIGH RISK",
    studioRecordsTagMedium: "MEDIUM",
    studioRecordsTagSecure: "SECURE",
    studioRecordsBatchTitle: "Batch analysis report",
    studioRecordsBatchDesc:
      "Generate a comprehensive risk overview for the last 50 scans to identify systematic vulnerabilities.",
    studioRecordsBatchCta: "Generate summary",
    studioRecordsHealthTitle: "Health status",
    studioRecordsHealthDesc:
      "Workspace scan compliance is healthy. 12 pending actions across 4 products.",
    studioComingShort: "Coming soon",
    studioMonTopicsAllAdded: "All available topics are already added",
    studioMonTestNotifySent: "Test notification sent",
    studioMonTestNotifyDenied:
      "Notification permission denied. Enable notifications for this site in your browser settings.",
    studioMonTestNotifyUnsupported:
      "This browser does not support system notifications",
    studioMonExportReportOk: "Exported current signals (JSON)",
    studioRecordsExported: "Exported scan records (JSON)",
    studioRecordsBatchSummaryOk: "Generated and downloaded batch summary (TXT)",
    studioDetailDisclaimerCopied: "Disclaimer draft copied to clipboard",
    studioDetailDisclaimerCopyFailed: "Copy failed — select text manually",
    studioDetailCompareAdded: "Added to compare set — opening records",
    sheCompareNeedScanFirst: "Run at least one scan before using compare",
    sheNoScansTitle: "No scans yet",
    sheNoScansLead:
      "Start your first compliance assessment to identify regulatory risks and gaps across your product claims.",
    sheNoScansLeadSub: "",
    sheRunFirstScan: "Run your first scan",
    sheCompareBadge: "Comparison tool",
    sheCompareTitle: "Compare scans",
    sheCompareDesc:
      "Select two scans from history to see resolved vs new risks. Track progress across regulatory cycles.",
    sheCompareDescSub: "",
    sheSelectHistory: "Select history",
    sheAlertsTitle: "Alerts disabled",
    sheAlertsDesc:
      "Enable alerts to monitor regulatory updates for your categories. Stay ahead of labeling and advertising rule changes.",
    sheAlertsDescSub: "",
    sheConfigureAlerts: "Configure alerts",
    studioFormTitle: "New compliance analysis",
    studioFormSubtitle:
      "Verify marketing claims against regulatory frameworks. Step 1/1: configuration & input (scan-only, not a chat).",
    studioMetaTitle: "Scan metadata",
    studioInternalName: "Product name",
    studioInternalNamePh:
      "Saved to scan history; can match internal SKU, e.g. VC-SERUM-01",
    studioVerticalLabel: "Product vertical",
    studioVerticalCosmetic: "Cosmetics",
    studioVerticalFood: "Food",
    studioVerticalSupplement: "Supplements",
    studioVerticalBaby: "Baby & kids",
    studioClaimsTitle: "Claims body",
    studioClaimsHint:
      "Paste raw product copy, packaging text, or marketing claims.",
    studioClaimsPh: "Enter claims text to analyze…",
    studioOptionsTitle: "Analysis options",
    studioOptFda: "Include FDA evidence block",
    studioOptFdaDesc:
      "We cite FDA public enforcement (openFDA sync) and FTC press releases (official RSS) as contextual evidence signals; data sources are continuously expanded.",
    studioOptSeries: "Attach to series for version tracking",
    studioOptSeriesDesc:
      "Save this scan under a series to compare with earlier versions of the same product line.",
    studioSeriesLabel: "Target series",
    studioSeriesPlaceholder: "Select a series",
    studioSeriesNewBtn: "New series",
    studioSeriesCreateModalTitle: "New series",
    studioSeriesNamePh: "e.g. SPF50 sunscreen line",
    studioSeriesCreateSuccess: "Series created",
    studioSeriesNeedSelect: "Select or create a series first",
    studioSeriesNameRequired: "Enter a series name",
    studioSeriesLoadFailed: "Could not load series. Check login and network.",
    studioSeriesSyncFailed:
      "Series saved locally; server sync failed. Check login and network.",
    studioSaveDraft: "Save draft",
    studioRunScan: "Run scan",
    studioScanning: "Scanning…",
    studioEstTime: "Estimate: ~45s per 1k words (depends on backend).",
    studioRiskPanelTitle: "Risk categories checked",
    studioRiskDisease: "Disease claims",
    studioRiskAdditive: "Unapproved additives",
    studioRiskIngredient: "Ingredient violations",
    studioRiskComparative: "Comparative claims",
    studioRiskEco: "Eco / sustainability",
    studioAuditTitle: "Audit note",
    studioAuditBody:
      "Scanning uses the XTool analysis engine. Findings are decision-support only, not legal advice.",
    studioNeedHelpTitle: "Need help?",
    studioNeedHelpBody:
      "Read the guide on structure/function claims to improve pass rate.",
    studioDocLink: "Documentation",
    studioDetailTitle: "Scan result detail",
    studioContinueScan: "New scan",
    studioNoClaims: "Please enter claims text to analyze.",
    studioScanFailed: "Scan failed",
    studioFdaEvidence: "Regulatory evidence",
    navFeedback: "Feedback",
    headerBadge: "FDA Rules Updated",
    loginEntry: "Login",
    logoutEntry: "Logout",
    userMenuConsoleOverview: "Console overview",
    openConsole: "Open Workspace",
    heroTitle: "Your US Market Compliance Copilot",
    slogan: "Claims Review for Cosmetics & Supplements",
    subtitle:
      "Paste product copy, and AI flags risky claims, explains why, and rewrites safely.",
    heroPrimaryAction: "Start Compliance Chat",
    heroSecondaryAction: "Open Workspace",
    heroHighlights: [
      "AI compliance conversation",
      "Chinese and English support",
      "FDA-aware risk rules",
    ],
    heroStatScans: "120K+ Claims Scanned",
    heroStatAccuracy: "94.2% Risk Hit Precision",
    heroStatUpdates: "Rule Refresh: Daily",
    heroFlowTitle: "How It Works",
    heroFlows: [
      "1. Start chat and paste claims",
      "2. Detect high-risk statements",
      "3. Get ready-to-use safer rewrites",
    ],
    authorityTitle: "FDA / FTC public evidence signals (continuously updated)",
    authorityDesc:
      "We cite FDA public enforcement (openFDA sync) and FTC-related public records as contextual evidence signals, combined with keyword rules and model review; we continuously expand data sources.",
    authorityItems: [
      "Covers high-risk claims in cosmetics and supplements",
      "Prioritizes disease-treatment and drug-like wording",
      "Provides actionable rewrites with explainable risk rationale",
    ],
    ruleVersionLabel: "Rule Version",
    ruleVersionValue: "FDA-2026.03",
    lastSyncLabel: "Last Sync",
    sourceLabel: "Source",
    sourceValue: "FDA (openFDA) + FTC (RSS); expanding sources",
    fdaStatusLabel: "FDA Endpoint",
    fdaStatusOnline: "Online",
    fdaStatusOffline: "Offline",
    loginRequiredTitle: "Login Required",
    loginRequiredDesc: "Please sign in before starting compliance chat.",
    loginNow: "Go to Login",
    sessionExpiredTitle: "Session expired",
    sessionExpiredDesc:
      "Your session is no longer valid. Please sign in again to continue.",
    sessionExpiredGoLogin: "Sign in",
    later: "Later",
    focusTitle: "Current Review Priorities",
    focusDesc:
      "Prioritize high-risk language that tends to draw enforcement attention; block first, then optimize conversion.",
    focusItems: [
      "Disease treatment or cure promises",
      "Guaranteed timeline claims (e.g., works in 7 days)",
      "Drug-like language in cosmetic/supplement copy",
    ],
    productFocusTitle: "Product Categories in Focus",
    productFocusItems: [
      "Supplements: sleep, weight loss, glucose, liver support",
      "Functional skincare: acne, repair, anti-inflammatory claims",
      "High-volume cross-border listings with aggressive efficacy copy",
    ],
    claimFocusTitle: "Claim Patterns in Focus",
    claimFocusItems: [
      "Treat / Cure / Diagnose",
      "Guaranteed / 100% effective / instant result",
      "Drug-mechanism style claims without compliant evidence framing",
    ],
    scanInputTitle: "Claims Scanner",
    chatHistoryTitle: "Chat History",
    newChat: "New Chat",
    assistantWelcome:
      "Hi, I am your US compliance assistant. Send claims copy and I will flag risks and rewrite suggestions.",
    chatInputPlaceholder:
      "Type claims text, e.g. This product treats insomnia and works in 7 days...",
    sendMessage: "Send",
    executeReview: "Run Compliance Review",
    scanToolkitEntry: "Enter Studio mode",
    scanToolkitShort: "Studio",
    scanToolkitProTag: "Pro",
    scanToolkitLockedTitle: "Pro or Enterprise required",
    scanToolkitLockedBody:
      "Upgrade to unlock Studio (Pro): PDF reports, version compare, regulatory alerts, and more.",
    complianceHubTitle: "Studio",
    complianceHubLead:
      "Studio is XTool’s professional scan workspace. Use it with Run Compliance Review in chat; modules will go live as the backend ships.",
    complianceHubPdfTitle: "Compliance PDF",
    complianceHubPdfDesc:
      "Export a branded report with citations and timestamps; optional company logo on paid plans.",
    complianceHubCompareTitle: "Version compare",
    complianceHubCompareDesc:
      "Compare successive scans to highlight resolved issues and new risks.",
    complianceHubAlertsTitle: "Regulatory alerts",
    complianceHubAlertsDesc:
      "Email digests for FDA/FTC-style updates by topics you follow.",
    complianceHubLockedTitle: "Studio is Pro / Enterprise only",
    complianceHubLockedLead: "Upgrade your plan to unlock Studio (Pro).",
    reviewCosts: "Costs 1 review credit",
    chatModeHint:
      "Free chat is available. Credits are only used when running compliance review.",
    creditsLabel: "Review Credits Left",
    currentPlanLabel: "Current plan",
    freeChatReply:
      "This is a free chat suggestion: I can help polish wording and structure. For FDA risk score, violation reasons, and ready-to-use rewrite output, run compliance review.",
    reviewUpsell:
      "Compliance conclusions are part of paid review output. Run one review task to unlock actionable result.",
    outOfCredits:
      "No review credits left. Please upgrade plan or buy more credits.",
    upgradePlanNow: "Upgrade Plan",
    scanningReply: "Analyzing...",
    scanInputPlaceholder:
      "Paste your marketing copy. Example: This product treats insomnia and anxiety in 7 days...",
    uploadLabel: "Text upload supported later (MVP uses direct paste)",
    uploadButton: "Upload Copy",
    scanButton: "Run Compliance Scan",
    scanning: "Scanning...",
    resultTitle: "Compliance Findings",
    scoreLabel: "Compliance Score",
    riskLevel: "Risk",
    phrase: "Risky Claim",
    reason: "Why It Is Risky",
    suggestion: "Suggested Rewrite",
    emptyResult: "Paste claims and run a scan to see findings here.",
    pricingTitle: "MVP Pricing",
    pricingFree: "Free trial: 3 scans",
    pricingOneTime: "One-time scan: $9.9",
    pricingMonth: "Monthly: $49 (10 scans)",
    pricingYear: "Yearly: $399 (Unlimited)",
    targetUsersTitle: "Target Users",
    targetUsers: [
      "Amazon / DTC sellers in cosmetics and supplements",
      "Cross-border operators and copywriters",
      "Global marketing teams for emerging brands",
    ],
    fdaTitle: "FDA / FTC public regulatory data",
    fdaDesc:
      "We cite FDA public enforcement (openFDA sync) and FTC press releases (official RSS) as contextual evidence signals; we continuously expand data sources.",
    fdaButton: "Check FDA API Connectivity",
    fdaOk: "FDA endpoint is reachable",
    fdaFail: "FDA endpoint is unavailable right now",
    pricingHeroTitle: "Simple pricing for solo sellers and full teams",
    pricingHeroDesc:
      "Pay per scan or subscribe based on your listing workflow and review volume.",
    pricingFeatureTitle: "Core Capabilities",
    pricingFeatures: [
      "AI risk detection with explainable rationale",
      "Bilingual scanning for Chinese and English",
      "FDA (openFDA) + FTC (RSS) evidence signals; expanding sources",
      "Audit trail and team collaboration hook (reserved)",
    ],
    priceFreeName: "Free Trial",
    priceFreeValue: "$0",
    priceFreePoints: ["3 scans", "Basic risk alerts", "Community support"],
    priceSingleName: "Single Scan",
    priceSingleValue: "$9.9",
    priceSinglePoints: [
      "1 deep scan",
      "Risk phrase pinpointing",
      "Rewrite suggestions",
    ],
    priceMonthName: "Monthly",
    priceMonthValue: "$49",
    priceMonthPoints: ["10 scans", "Scan history", "Priority support"],
    priceYearName: "Yearly",
    priceYearValue: "$399",
    priceYearPoints: ["Unlimited scans", "Team seats", "Priority API access"],
    choosePlan: "Choose Plan",
    pricingInWorkspaceTitle: "Subscription Plans",
    pricingInWorkspaceDesc:
      "Monthly and yearly billing. Yearly saves around 15%.",
    planMonthlyLabel: "Monthly",
    planYearlyLabel: "Yearly",
    planSaveHint: "Save around 10%-20% with annual billing",
    personalPlanName: "Personal",
    personalMonthly: "$20 /month · 30 scans",
    personalYearly: "$204 /year · 360 scans",
    personalFeatures: [
      "Built for solo operators",
      "Core AI claim review",
      "Email support",
    ],
    proPlanName: "Pro",
    proMonthly: "$40 /month · 70 scans",
    proYearly: "$408 /year · 840 scans",
    proFeatures: [
      "Professional Studio workbench: dedicated scans, scan history, regulatory monitoring, and other Pro tools",
      "Built for small teams",
      "Priority queue",
      "Advanced rewrite suggestions",
    ],
    enterprisePlanName: "Enterprise",
    enterpriseMonthly: "$99 /month · Unlimited scans",
    enterpriseYearly: "$999 /year · Unlimited scans",
    enterpriseFeatures: [
      "Everything in Pro",
      "Custom compliance policy",
      "API access",
      "Dedicated success manager",
    ],
    currentPlanTag: "Current plan",
    upgradePricingCardTitle: "Plans & pricing",
    upgradeBetaBanner:
      "We're in public beta: paid upgrades are not available yet. Pricing below is for reference only; we'll announce when checkout opens.",
    upgradeBetaModalTitle: "Upgrade not available",
    upgradeBetaModalBody:
      "We're in public beta and do not support plan upgrades yet. Please watch for updates.",
    upgradeBetaModalOk: "OK",
    upgradeFreeYouAreOn: "You are on the Free plan",
    upgradeFreeTierCaption: "Free starter tier (basic quota and capabilities)",
    enterpriseIncludesProRow: "Everything in Pro included",
    profileTitle: "Profile",
    profileAccount: "Account: ops@brand.com",
    profileRole: "Role: Owner",
    profileSubscription: "Subscription: Pro Annual",
    profileRenewDate: "Renewal: 2026-04-21",
    dashboardTitle: "Operations Overview",
    dashboardDesc:
      "Track risky claims, scan performance, and compliance trends.",
    dashboardMyAccount: "My account",
    dashboardAccountUnavailable: "Could not load account",
    dashboardFieldRole: "Role",
    dashboardUserId: "User ID",
    statTodayScans: "Scans Today",
    statRiskBlocks: "High Risks Blocked",
    statAvgScore: "Average Score",
    dashboardUsageMeterApi: "API allowance used",
    dashboardUsageMeterQuota: "Monthly scan quota",
    dashboardUsageMeterGeneric: "Usage",
    dashboardUsageMeterHintApi:
      "Share of your plan's API allowance used (0–100%). This is not your review credit balance.",
    dashboardUsageMeterHintQuota:
      "Scans used this month divided by your plan's monthly scan quota. Review credits are separate—see Billing or scan UI.",
    dashboardUsageMeterHintNone: "Shows 0% when the server does not return usage data.",
    recentTitle: "Recent Scans",
    recentColumns: ["Time", "Product", "Risk", "Status"],
    recentRows: [
      ["15:20", "Sleep gummy listing", "High", "Rewrite suggested"],
      ["14:05", "Acne serum PDP", "Medium", "Approved"],
      ["10:43", "Liver support ad copy", "High", "Pending"],
    ],
    billingTitle: "Billing & Subscription",
    billingDesc:
      "Track active plan, usage, and payment records. Upgrade or switch plans anytime.",
    billingCurrentPlan: "Current plan: Monthly $49",
    billingRenewDate: "Next renewal: 2026-04-21",
    billingUsage: "Usage this month: 6 / 10 scans",
    billingHistoryTitle: "Payment History",
    billingHistoryColumns: ["Date", "Item", "Amount", "Status"],
    billingRows: [
      ["2026-03-21", "Monthly plan", "$49", "Paid"],
      ["2026-02-21", "Monthly plan", "$49", "Paid"],
      ["2026-02-02", "Single scan", "$9.9", "Paid"],
    ],
    billingAction: "Manage payment method",
    feedbackTitle: "Feedback",
    feedbackDesc: "Leave your contact details and issue. We will follow up.",
    feedbackContactLabel: "Contact",
    feedbackContactPlaceholder: "Email",
    feedbackQuestionLabel: "Issue",
    feedbackQuestionPlaceholder:
      "Please enter a description of the issue you encountered or the steps to reproduce it.",
    feedbackSubmit: "Submit Feedback",
    feedbackSubmitSuccess: "Feedback submitted. We will contact you soon.",
    feedbackHistoryTitle: "Feedback Records",
    feedbackColCreated: "Created At",
    feedbackColContact: "Contact",
    feedbackColQuestion: "Issue",
    feedbackColStatus: "Status",
    feedbackStatusOpen: "Open",
    feedbackStatusReviewing: "Reviewing",
    feedbackStatusResolved: "Resolved",
    feedbackEmpty: "No feedback records yet",
    backToHome: "Back to Home",
    loginTitle: "Sign in to your compliance workspace",
    loginDesc:
      "Manage claim risks, scan history, and rewriting versions in one place.",
    loginEmail: "Email",
    loginPassword: "Password",
    loginConfirmPassword: "Confirm Password",
    loginCode: "Verification Code",
    loginTabSignIn: "Sign In",
    loginTabSignUp: "Sign Up",
    sendCode: "Send Code",
    resendIn: "resend in",
    codeSent: "Verification code sent. Please check your email (demo).",
    registerButton: "Create Account",
    passwordRuleHint:
      "Password must be at least 8 characters with letters and numbers.",
    loginRemember: "Remember me",
    loginButton: "Sign In",
    loginForgot: "Forgot password?",
    loginByGoogle: "Continue with Google",
    loginByAmazon: "Continue with Amazon",
    loginNoAccount: "No account yet?",
    loginCreate: "Create account",
    loginEmailOnlyNote:
      "Sign in with email and password. Sign up requires an email verification code.",
    langSwitch: "中",
    seoDocumentTitle: "US Compliance Shield | XTool",
    seoMetaDescription:
      "US Compliance Shield — scan cosmetics and supplement claims for US-market compliance: FDA/FTC-aware copy review, risk flags, and regulatory context for cross-border sellers.",
    seoKeywords:
      "FDA,FTC,compliance,cosmetics,dietary supplements,claims review,US market,copy scan,regulatory intelligence,XTool,US Compliance Shield",
    seoOgSiteName: "XTool",
    seoOgImageAlt:
      "XTool US Compliance Shield — claims compliance scanning and regulatory intelligence for US-market sellers",
    seoSchemaFeatures: [
      "One-click scans for cosmetics and dietary supplement claims with risk scoring",
      "FDA/FTC-aware context using public regulatory signals and enforcement patterns",
      "Studio: scan series, PDF compliance reports, and version diff (Pro)",
      "Monitoring topics and email alerts for public regulatory updates in your categories",
      "Chinese and English UI for cross-border and US-based teams",
    ],
  },
};

export function getPdfTemplateLabels(t: TextSchema): PdfTemplateLabels {
  return {
    reportTitle: t.studioPdfReportTitle,
    summaryTitle: t.studioPdfSummaryTitle,
    findingsTitle: t.studioPdfFindingsTitle,
    regsTitle: t.studioPdfRegsTitle,
    appendixTitle: t.studioPdfAppendixTitle,
    reportId: t.studioPdfReportId,
    generatedDate: t.studioPdfGeneratedDate,
    category: t.studioPdfCategory,
    skuRef: t.studioPdfSkuRef,
    company: t.studioPdfCompany,
    summaryAssessment: t.studioPdfSummaryAssessment,
    overallRiskPrefix: t.studioPdfOverallRiskPrefix,
    coverDisclaimer: t.studioPdfCoverDisclaimer,
    complianceScore: t.studioPdfComplianceScore,
    analysisScope: t.studioPdfAnalysisScope,
    targetMarket: t.studioPdfTargetMarket,
    channel: t.studioPdfChannel,
    wordCount: t.studioPdfWordCount,
    productType: t.studioPdfProductType,
    riskStats: t.studioPdfRiskStats,
    riskHigh: t.studioPdfRiskHigh,
    riskMed: t.studioPdfRiskMed,
    riskLow: t.studioPdfRiskLow,
    execSummary: t.studioPdfExecSummary,
    colPhrase: t.studioPdfColPhrase,
    colRisk: t.studioPdfColRisk,
    colReason: t.studioPdfColReason,
    colSuggest: t.studioPdfColSuggest,
    impact: t.studioPdfImpact,
    defaultMarket: t.studioPdfDefaultMarket,
    defaultChannel: t.studioPdfDefaultChannel,
    brandSentinel: t.studioPdfBrandSentinel,
    noFlagged: t.studioPdfNoFlagged,
    noSummary: t.studioPdfNoSummary,
    noClaims: t.studioPdfNoClaims,
    riskCritical: t.studioPdfRiskCritical,
    riskWarning: t.studioPdfRiskWarning,
    riskObservation: t.studioPdfRiskObservation,
    regMatchTitle: t.studioPdfRegMatchTitle,
    regEvidenceImpact: t.studioPdfRegEvidenceImpact,
    regEx1Title: t.studioPdfRegEx1Title,
    regEx1Body: t.studioPdfRegEx1Body,
    regEx1Impact: t.studioPdfRegEx1Impact,
    regEx2Title: t.studioPdfRegEx2Title,
    regEx2Body: t.studioPdfRegEx2Body,
    regEx2Impact: t.studioPdfRegEx2Impact,
    regEx3Title: t.studioPdfRegEx3Title,
    regEx3Body: t.studioPdfRegEx3Body,
    regEx3Impact: t.studioPdfRegEx3Impact,
  };
}
